import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
// Limitless imports
import { useTranslation } from "@limitless/common/hooks/translation/TranslationContext";
import { getTabsContainerStyle, PortalButton, Separator, ConversationTabs } from "../../../..";
import OnboardingReviewCriteriaSummary from "./OnboardingReviewCriteriaSummary";
import { ConversationTab } from "../../../..";
const useStyles = makeStyles(theme => ({
  tabsContainer: getTabsContainerStyle(theme),
  reviewContainer: {
    minHeight: "2em",
    flexGrow: 1,
    overflow: "auto"
  },
  footerContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    justifyContent: "flex-end",
    marginBottom: 16,
    alignItems: "flex-end"
  }
}));
const ConversationReviewCriteriaPanel = ({
  message,
  onBackClick
}) => {
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  const startingTab = 0;
  const [selectedTab, setSelectedTab] = React.useState(startingTab);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.tabsContainer
  }, /*#__PURE__*/React.createElement(ConversationTabs, {
    activeTab: selectedTab,
    onTabChange: setSelectedTab,
    message: message,
    showKnowledge: false
  }, /*#__PURE__*/React.createElement(ConversationTab, {
    id: "detailedReviewTab",
    label: "Review"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.reviewContainer
  }, selectedTab === 0 && /*#__PURE__*/React.createElement(OnboardingReviewCriteriaSummary, {
    message: message
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.footerContainer
  }, /*#__PURE__*/React.createElement(Separator, {
    color: "default"
  }), /*#__PURE__*/React.createElement(PortalButton, {
    id: "backConversation",
    onClick: onBackClick
  }, t("Back"))));
};
ConversationReviewCriteriaPanel.propTypes = {
  message: PropTypes.object.isRequired,
  onBackClick: PropTypes.func.isRequired
};
export default ConversationReviewCriteriaPanel;